var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16C4 12.6863 6.68629 10 10 10H54C57.3137 10 60 12.6863 60 16V48C60 51.3137 57.3137 54 54 54H10C6.68629 54 4 51.3137 4 48V16Z",
    fill: "url(#paint0_linear_1_496)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 32C38.4183 32 42 28.4183 42 24C42 19.5817 38.4183 16 34 16C29.5817 16 26 19.5817 26 24C26 28.4183 29.5817 32 34 32Z",
    fill: "url(#paint1_linear_1_496)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32C50.4183 32 54 28.4183 54 24C54 19.5817 50.4183 16 46 16C41.5817 16 38 19.5817 38 24C38 28.4183 41.5817 32 46 32Z",
    fill: "url(#paint2_linear_1_496)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37C10 35.8954 10.8954 35 12 35H26C27.1046 35 28 35.8954 28 37C28 38.1046 27.1046 39 26 39H12C10.8954 39 10 38.1046 10 37Z",
    fill: "url(#paint3_linear_1_496)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 43C10.8954 43 10 43.8954 10 45C10 46.1046 10.8954 47 12 47H14C15.1046 47 16 46.1046 16 45C16 43.8954 15.1046 43 14 43H12Z",
    fill: "url(#paint4_linear_1_496)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 43C20.8954 43 20 43.8954 20 45C20 46.1046 20.8954 47 22 47H24C25.1046 47 26 46.1046 26 45C26 43.8954 25.1046 43 24 43H22Z",
    fill: "url(#paint5_linear_1_496)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45C30 43.8954 30.8954 43 32 43H34C35.1046 43 36 43.8954 36 45C36 46.1046 35.1046 47 34 47H32C30.8954 47 30 46.1046 30 45Z",
    fill: "url(#paint6_linear_1_496)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43C40.8954 43 40 43.8954 40 45C40 46.1046 40.8954 47 42 47H44C45.1046 47 46 46.1046 46 45C46 43.8954 45.1046 43 44 43H42Z",
    fill: "url(#paint7_linear_1_496)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_496",
    x1: 60,
    y1: 54,
    x2: 17.2492,
    y2: -0.410096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.201715,
    stopColor: "#2E2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566C80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_496",
    x1: 42,
    y1: 32,
    x2: 26,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_496",
    x1: 38,
    y1: 16,
    x2: 54,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_496",
    x1: 14.5,
    y1: 40,
    x2: 14.5,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_496",
    x1: 19,
    y1: 48,
    x2: 19,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_496",
    x1: 19,
    y1: 48,
    x2: 19,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_496",
    x1: 19,
    y1: 48,
    x2: 19,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_496",
    x1: 19,
    y1: 48,
    x2: 19,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155999,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796276,
    stopColor: "#B9AA99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.fbb159a9a96ac523e52e5a8e9d696dc2.svg";
export { ForwardRef as ReactComponent };